var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle-Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M52,13.5a36,36,0,1,0,36,36A36,36,0,0,0,52,13.5ZM52,81A31.5,31.5,0,1,1,83.5,49.5,31.53,31.53,0,0,1,52,81ZM63.25,35.07,52,46.32,40.75,35.07l-3.18,3.18L48.82,49.5,37.57,60.75l3.18,3.18L52,52.68,63.25,63.93l3.18-3.18L55.18,49.5,66.43,38.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDelete);
export default __webpack_public_path__ + "static/media/CircleDelete.c11c09b8c3cc580d5006cff3b23e9d22.svg";
export { ForwardRef as ReactComponent };